<div class="modal-header">
  <h4 id="merge-into-modal" class="modal-title">
    {{ "Migrate legacy items into this one" | translate }}
  </h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <ng-container *ngIf="(this.loadingService.loading$ | async) === false; else loading">
    <ng-container *ngIf="similarLegacyItems.length > 0; else noSimilarItems">
      <p [innerHTML]="message" class="alert alert-info"></p>

      <form [formGroup]="form" class="mt-4 ms-3">
        <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
      </form>
    </ng-container>
  </ng-container>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="migrateButtonDisabled()"
    (click)="migrate()"
    class="btn btn-danger"
    type="button"
  >
    {{ "Migrate" | translate }}
  </button>
</div>

<ng-template #noSimilarItems>
  <p>
    {{ "We couldn't find any similar items in the legacy database." | translate }}
  </p>
</ng-template>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
